<template>
    <div class="content">
        <img :src="upDataImg" alt="" />
    </div>
</template>
<script>
import { getWxSingleConfig } from "@/js/wx.js";
import oStorage from '@/libsV2/storage.js';
export default {
    data() {
        return {
            upDataImg: "",
        };
    },
    created() {
        let _that = this;
        this.$toast("长按可保存图片~");
        // let upDataImg = localStorage.getItem("dateImgUrl");
        let upDataImg = oStorage.getStorage("dateImgUrl");
        _that.$store.commit("loadSwitch", true);
        $init(() => {
            let confit = {
                share_friend_title: "AI-LiNK冷暖风水签单喜报",
                share_friend_desc: "中央空调·采暖·新风·全屋用水",
                share_img_url:
                    "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/xb_icon.jpg",
                share_link: `${window.location.protocol}//${window.location.host}/other/poster/sales`,
            };
            getWxSingleConfig(confit);
        });
        let img = new Image();
        img.src = upDataImg;
        img.onload = function () {
            _that.upDataImg = upDataImg;
            _that.$store.commit("loadSwitch", false);
        };
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 100vh;
    img {
        width: 100%;
    }
}
</style>
